import { cva } from "../../../styled-system/css";

export const contentWrapperRecipe = cva({
  base: {
    tablet: {
      minHeight: "240px",
    },
    desktop: {
      marginBottom: "100px",
    },
  },
  variants: {
    imageSize: {
      small: {
        marginBottom: "60px",
      },
      big: {
        marginBottom: 0,
      },
    },
  },
  defaultVariants: {
    imageSize: "small",
  },
});

export const mainImageWrapperRecipe = cva({
  base: {
    maxWidth: "333px",
    marginTop: "baseUnit.mobile1",
    marginInline: "auto",
    marginBottom: 0,
    tablet: {
      position: "absolute",
      maxWidth: "390px",
      marginTop: "baseUnit.mobile2",
      marginInline: "auto",
      marginBottom: 0,
    },
  },
  variants: {
    imageSize: {
      small: {
        desktop: {
          maxWidth: "496px",
          margin: 0,
        },
      },
      big: {
        desktop: {
          maxWidth: "641px",
          margin: 0,
        },
      },
    },
  },
  defaultVariants: {
    imageSize: "small",
  },
});
